interface TextBodyProps {
	block: any
}


const TextBody = (props: TextBodyProps) => {

	const { block } = props

	return (
		<div key={block.id} className="body">
			<div className="body__wrapper">
				<div className='body__content' dangerouslySetInnerHTML={{ __html: block.body }} />
			</div>
		</div>
	)

}

export default TextBody
